import { BlockType } from '../terrain'
import { InventoryItemType, ItemType } from '../items'

import grass from '../default-textures-master/textures/blocks/grass_side_carried.png'
import sand from '../default-textures-master/textures/blocks/sand.png'
import tree from '../default-textures-master/textures/blocks/log_oak.png'
import leaf from '../default-textures-master/textures/blocks/leaves_oak_opaque.png'
import dirt from '../default-textures-master/textures/blocks/dirt.png'
import stone from '../default-textures-master/textures/blocks/stone.png'
import coal from '../default-textures-master/textures/blocks/coal_ore.png'
import wood from '../default-textures-master/textures/blocks/planks_oak.png'
import diamond from '../default-textures-master/textures/blocks/diamond_block.png'
import quartz from '../default-textures-master/textures/blocks/quartz_block_side.png'
import glass from '../default-textures-master/textures/blocks/glass.png'
import bedrock from '../default-textures-master/textures/blocks/bedrock.png'
import craftingTable from '../default-textures-master/textures/blocks/crafting_table_front.png'
import water from '../default-textures-master/textures/blocks/water_placeholder.png'
import rawBeef from '../default-textures-master/textures/items/beef_raw.png'
import cookedBeef from '../default-textures-master/textures/items/beef_cooked.png'
import stick from '../default-textures-master/textures/items/stick.png'
import woodenPickaxe from '../default-textures-master/textures/items/wood_pickaxe.png'
import leather from '../default-textures-master/textures/items/leather.png'
import rawPorkchop from '../default-textures-master/textures/items/porkchop_raw.png'
import cookedPorkchop from '../default-textures-master/textures/items/porkchop_cooked.png'
import rawMutton from '../default-textures-master/textures/items/mutton_raw.png'
import cookedMutton from '../default-textures-master/textures/items/mutton_cooked.png'
import rawChicken from '../default-textures-master/textures/items/chicken_raw.png'
import cookedChicken from '../default-textures-master/textures/items/chicken_cooked.png'
import feather from '../default-textures-master/textures/items/feather.png'
import egg from '../default-textures-master/textures/items/egg.png'
import rawRabbit from '../default-textures-master/textures/items/rabbit_raw.png'
import cookedRabbit from '../default-textures-master/textures/items/rabbit_cooked.png'
import rabbitHide from '../default-textures-master/textures/items/rabbit_hide.png'
import rabbitFoot from '../default-textures-master/textures/items/rabbit_foot.png'
import wool from '../default-textures-master/textures/blocks/wool_colored_white.png'
import rottenFlesh from '../default-textures-master/textures/items/rotten_flesh.png'
import bone from '../default-textures-master/textures/items/bone.png'
import string from '../default-textures-master/textures/items/string.png'
import spiderEye from '../default-textures-master/textures/items/spider_eye.png'
import gunpowder from '../default-textures-master/textures/items/gunpowder.png'
import netherrack from '../static/textures/block/netherrack.png'
import soulSand from '../static/textures/block/soul_sand.png'
import glowstone from '../static/textures/block/glowstone.png'
import netherQuartz from '../static/textures/block/nether_quartz_ore.png'

const netherPortal = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16'><rect width='16' height='16' fill='%239a22f8' fill-opacity='0.7'/></svg>"
import lava from '../default-textures-master/textures/blocks/lava_placeholder.png'
import obsidian from '../static/textures/block/obsidian.png'
import cobblestone from '../default-textures-master/textures/blocks/cobblestone.png'
import tnt from '../static/textures/block/tnt_side.png'
import stonePickaxe from '../default-textures-master/textures/items/stone_pickaxe.png'
import bucket from '../default-textures-master/textures/items/bucket_empty.png'
import waterBucket from '../default-textures-master/textures/items/bucket_water.png'
import lavaBucket from '../default-textures-master/textures/items/bucket_lava.png'

export const blockIcons: Record<InventoryItemType, string> = {
  [BlockType.grass]: grass,
  [BlockType.sand]: sand,
  [BlockType.tree]: tree,
  [BlockType.leaf]: leaf,
  [BlockType.dirt]: dirt,
  [BlockType.stone]: stone,
  [BlockType.coal]: coal,
  [BlockType.wood]: wood,
  [BlockType.diamond]: diamond,
  [BlockType.quartz]: quartz,
  [BlockType.glass]: glass,
  [BlockType.bedrock]: bedrock,
  [BlockType.craftingTable]: craftingTable,
  [BlockType.water]: water,
  [ItemType.rawBeef]: rawBeef,
  [ItemType.cookedBeef]: cookedBeef,
  [ItemType.stick]: stick,
  [ItemType.woodenPickaxe]: woodenPickaxe,
  [ItemType.leather]: leather,
  [ItemType.rawPorkchop]: rawPorkchop,
  [ItemType.cookedPorkchop]: cookedPorkchop,
  [ItemType.rawMutton]: rawMutton,
  [ItemType.cookedMutton]: cookedMutton,
  [ItemType.rawChicken]: rawChicken,
  [ItemType.cookedChicken]: cookedChicken,
  [ItemType.feather]: feather,
  [ItemType.egg]: egg,
  [ItemType.rawRabbit]: rawRabbit,
  [ItemType.cookedRabbit]: cookedRabbit,
  [ItemType.rabbitHide]: rabbitHide,
  [ItemType.rabbitFoot]: rabbitFoot,
  [ItemType.wool]: wool,
  [ItemType.rottenFlesh]: rottenFlesh,
  [ItemType.bone]: bone,
  [ItemType.string]: string,
  [ItemType.spiderEye]: spiderEye,
  [ItemType.gunpowder]: gunpowder,
  [BlockType.lava]: lava,
  [BlockType.obsidian]: obsidian,
  [BlockType.cobblestone]: cobblestone,
  [BlockType.tnt]: tnt,
  [ItemType.stonePickaxe]: stonePickaxe,
  [ItemType.bucket]: bucket,
  [ItemType.waterBucket]: waterBucket,
  [ItemType.lavaBucket]: lavaBucket,
  [BlockType.whitespaceGrass]: grass,
  [BlockType.whitespaceDirt]: dirt,
  [BlockType.whitespaceLog]: tree,
  [BlockType.whitespaceLeaf]: leaf,
  [BlockType.netherrack]: netherrack,
  [BlockType.soulSand]: soulSand,
  [BlockType.glowstone]: glowstone,
  [BlockType.netherQuartz]: netherQuartz,
  [BlockType.netherPortal]: netherPortal
}

export const blockNames: Record<InventoryItemType, string> = {
  [BlockType.grass]: 'Grass',
  [BlockType.sand]: 'Sand',
  [BlockType.tree]: 'Oak Log',
  [BlockType.leaf]: 'Leaves',
  [BlockType.dirt]: 'Dirt',
  [BlockType.stone]: 'Stone',
  [BlockType.coal]: 'Coal Ore',
  [BlockType.wood]: 'Oak Planks',
  [BlockType.diamond]: 'Diamond Block',
  [BlockType.quartz]: 'Quartz',
  [BlockType.glass]: 'Glass',
  [BlockType.bedrock]: 'Bedrock',
  [BlockType.craftingTable]: 'Crafting Table',
  [BlockType.water]: 'Water',
  [ItemType.rawBeef]: 'Raw Beef',
  [ItemType.cookedBeef]: 'Steak',
  [ItemType.stick]: 'Stick',
  [ItemType.woodenPickaxe]: 'Wooden Pickaxe',
  [ItemType.leather]: 'Leather',
  [ItemType.rawPorkchop]: 'Raw Porkchop',
  [ItemType.cookedPorkchop]: 'Cooked Porkchop',
  [ItemType.rawMutton]: 'Raw Mutton',
  [ItemType.cookedMutton]: 'Cooked Mutton',
  [ItemType.rawChicken]: 'Raw Chicken',
  [ItemType.cookedChicken]: 'Cooked Chicken',
  [ItemType.feather]: 'Feather',
  [ItemType.egg]: 'Egg',
  [ItemType.rawRabbit]: 'Raw Rabbit',
  [ItemType.cookedRabbit]: 'Cooked Rabbit',
  [ItemType.rabbitHide]: 'Rabbit Hide',
  [ItemType.rabbitFoot]: 'Rabbit Foot',
  [ItemType.wool]: 'Wool',
  [ItemType.rottenFlesh]: 'Rotten Flesh',
  [ItemType.bone]: 'Bone',
  [ItemType.string]: 'String',
  [ItemType.spiderEye]: 'Spider Eye',
  [ItemType.gunpowder]: 'Gunpowder',
  [BlockType.lava]: 'Lava',
  [BlockType.obsidian]: 'Obsidian',
  [BlockType.cobblestone]: 'Cobblestone',
  [BlockType.tnt]: 'TNT',
  [ItemType.stonePickaxe]: 'Stone Pickaxe',
  [ItemType.bucket]: 'Bucket',
  [ItemType.waterBucket]: 'Water Bucket',
  [ItemType.lavaBucket]: 'Lava Bucket',
  [BlockType.whitespaceGrass]: 'White Grass',
  [BlockType.whitespaceDirt]: 'White Dirt',
  [BlockType.whitespaceLog]: 'White Log',
  [BlockType.whitespaceLeaf]: 'White Leaves',
  [BlockType.netherrack]: 'Netherrack',
  [BlockType.soulSand]: 'Soul Sand',
  [BlockType.glowstone]: 'Glowstone',
  [BlockType.netherQuartz]: 'Nether Quartz Ore',
  [BlockType.netherPortal]: 'Nether Portal'
}
